import { render, staticRenderFns } from "./DateRangePickerBase.vue?vue&type=template&id=1b54d0a6&scoped=true"
import script from "./DateRangePickerBase.vue?vue&type=script&lang=js"
export * from "./DateRangePickerBase.vue?vue&type=script&lang=js"
import style0 from "./DateRangePickerBase.vue?vue&type=style&index=0&id=1b54d0a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b54d0a6",
  null
  
)

export default component.exports